import template
    from 'employer/templates/reports/leave/DetailsModal.ejs';

module.exports = Backbone.View.extend({
    initialize: function(options) {
        this.options = _.defaults(options || {}, {
            types:      null,
            employee:   null,
            entitled:   null,
            taken:      null,
            cf:         null,
        });

        return this.render();
    },

    render: function() {
        this.$el.html(template({
            employee:   this.options.employee,
            types:      this.options.types,
            entitled:   this.options.entitled,
            taken:      this.options.taken,
            cf:         this.options.cf,
        }));
    },

    show: function() {
        this.$('.modal').modal('show');
    },

    hide: function() {
        this.$('.modal').modal('hide');
    }
});



// WEBPACK FOOTER //
// ./app/employer/views/reports/DetailsModalView.js